import React from 'react';

import { WpModal, WpModalBody, WpModalHeader } from 'Wpds/components/modal';

import Transcription from '../Transcription';

type Props = {
  isOpen: boolean;
  transcription?: string;
  sources: Array<string>;
  onToggle(): void;
};

function VideoPlayerModal({ isOpen, onToggle, sources, transcription }: Props): React.ReactElement {
  return (
    <WpModal size="lg" isOpen={isOpen} onToggle={onToggle}>
      <WpModalHeader>Video Player</WpModalHeader>
      <WpModalBody>
        <video playsInline controls autoPlay width="100%">
          {sources.map(source => source && <source key={source} src={source} />)}
        </video>
        {transcription ? <Transcription fullText className="transcription mt-2" text={transcription} /> : null}
      </WpModalBody>
    </WpModal>
  );
}

export default VideoPlayerModal;
